module.exports = __webpack_public_path__ + "static/Mark2-6c9fe722b33d681d7e826d116a57fad7.jpg";